export enum AlertType {
  OUT_OF_FOCUS = "out_of_focus",
  TISSUE_IN_SLIDE = "tissue_in_slide",
}

export enum AlertResolution {
  NONE = "none",
}

export enum TechnicalScreeningClass {
  ERROR_DATA = "error_data",
  NOT_READY_DATA = "not_ready_data",
  OUT_OF_FOCUS = "Out of focus",
  INADAQUATE_TISSUE = "Inadequate tissue",
  IHC = "IHC",
}

export enum SlideDeletion {
  ADMIN = "admin",
}
